import {
  FilterMode,
  QueryPatternCreateMutationVariables,
  QueryPattern_OrderBy,
  QueryPattern,
  SortOrder,
  QueryPattern_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const queryPatternService = {
  createOne: buildCreateOne(
    (queryPatternCreateVariables: QueryPatternCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.queryPatternCreate(
          queryPatternCreateVariables
        );
        return result.queryPatternCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.queryPatternOne({ id });
    return result.queryPatternOne as QueryPattern;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: QueryPattern_OrderBy[] | null = null,
    filter: QueryPattern_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: QueryPattern_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
          { pattern: { contains: searchValue, mode: FilterMode.Insensitive } },
          {
            exampleInstantiation: {
              contains: searchValue,
              mode: FilterMode.Insensitive,
            },
          },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.queryPatternListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [
            { name: SortOrder.Asc },
            { pattern: SortOrder.Asc },
            { exampleInstantiation: SortOrder.Asc },
          ],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.queryPatternListWithOffset
    ) as QueryPattern[];
    return { list, orderBy };
  },
};
